import { v4 as uuidv4 } from 'uuid'

export function getUuid() {
  try {
    return uuidv4()
  } catch (e) {
    // non-blocking since only analytics
    return ''
  }
}
